import React, { useEffect, useRef } from 'react';
import Button from "./Button";

const BlogPostCta = () => {
    const trustpilotWidgetRef = useRef(null);
    useEffect(() => {
        // Function to attempt reinitialization of Trustpilot widgets
        const reinitializeTrustpilotWidgets = () => {
            if (window.Trustpilot && trustpilotWidgetRef.current) {
                window.Trustpilot.loadFromElement(trustpilotWidgetRef.current, true);
            }
        };

        // Observe the entire body for the addition of child elements if needed
        // You might not need a MutationObserver if you're just initializing once on component mount

        // Ensure Trustpilot widgets are reinitialized on initial load
        reinitializeTrustpilotWidgets();

        // Optionally, you might set up a MutationObserver or other logic here if you need to detect dynamic changes
    }, []);

    return (
        <div className="bg-light-blue py-12">
            <div className="container mx-auto">
                <div className="grid grid-cols-full p10 gap-4 items-center text-center px-4">
                    <h3>Need professional financial advice?</h3>
                    <p>We have 18 offices across the globe and we manage over $2billion for our 20,000+ clients</p>
                    <div className="flex justify-center">
                        <Button color="holborn-green" href="/enquiry-form">Get started</Button>
                    </div>
                    <div
                        ref={trustpilotWidgetRef}
                        className="trustpilot-widget pt-3"
                        data-locale="en-GB"
                        data-template-id="5419b732fbfb950b10de65e5"
                        data-businessunit-id="58bff1ac0000ff00059e0e97"
                        data-style-height="24px"
                        data-style-width="100%"
                        data-theme="light">
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogPostCta;